/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx } from '@atlaskit/css';
import Link from '@atlaskit/link/link';

import { extractProductNameFromARI } from './ari';
import { transformIfConfluenceLink } from './url-transformer/transform-if-confluence-link';

export type OnClickSource = (
	type: string,
	citedProduct: string | null,
	product: string | null,
	index?: number,
) => void;

/**
 * Builds a fallback link component for a source SmartCard that fails to resolve.
 */
export const createFallbackComponent =
	(
		url: string,
		type: string,
		title?: string,
		ari?: string | null,
		product?: string | null,
		onClickSource?: OnClickSource,
		shouldAddConfluenceAttribution?: boolean,
		index?: number,
	) =>
	(): JSX.Element => {
		const transformedUrl = transformIfConfluenceLink(url, shouldAddConfluenceAttribution);
		return (
			<Link
				href={transformedUrl}
				target="_blank"
				rel="noopener noreferrer"
				onClick={() => {
					if (onClickSource) {
						onClickSource(type, extractProductNameFromARI(ari), product ?? null, index);
					}
				}}
			>
				{title || url}
			</Link>
		);
	};
